import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';

export default class PasswordPolicyUIListener extends UIListener {

    constructor() {
        super();
    }

    public onPropertyValueUpdated(context: DetailViewContext, property: string) {
        this.updateGUI(context);
    }

    public onDetailViewReady(context: DetailViewContext) {
        this.updateGUI(context);
    }

    private updateGUI(context: DetailViewContext) {
        let isEnabled = context.genericObject.getObservable('IsEnabled');
        let isPasswordChronicEnabled = context.genericObject.getObservable('IsPasswordChronicEnabled');
        let isPasswordComplexityGroup1Enabled = context.genericObject.getObservable('IsPasswordComplexityGroup1Enabled');
        let isPasswordComplexityGroup2Enabled = context.genericObject.getObservable('IsPasswordComplexityGroup2Enabled');
        let isPasswordComplexityGroup3Enabled = context.genericObject.getObservable('IsPasswordComplexityGroup3Enabled');
        let isPasswordComplexityGroup4Enabled = context.genericObject.getObservable('IsPasswordComplexityGroup4Enabled');
        let isPasswordEntropyEnabled = context.genericObject.getObservable("IsPasswordEntropyEnabled");
        let isPasswordMultiCharUsageEnabled = context.genericObject.getObservable("IsPasswordMultiCharUsageEnabled");

        let lastChronicProhibitedUI = context.getUIFactory('LastChronicProhibited') as ControlFactory;
        let lastChronicProhibitedUIErrorMessage = context.getUIFactory('LastChronicProhibitedErrorMessage.Value') as ControlFactory;
        let isPasswordChronicEnabledUI = context.getUIFactory('IsPasswordChronicEnabled') as ControlFactory;
        let passwordComplexityGroup1 = context.getUIFactory('PasswordComplexityGroup1') as ControlFactory;
        let passwordComplexityGroup2 = context.getUIFactory('PasswordComplexityGroup2') as ControlFactory;
        let passwordComplexityGroup3 = context.getUIFactory('PasswordComplexityGroup3') as ControlFactory;
        let passwordComplexityGroup4 = context.getUIFactory('PasswordComplexityGroup4') as ControlFactory;
        let passwordComplexityGroup1ErrorMessage = context.getUIFactory('PasswordComplexityGroup1ErrorMessage.Value') as ControlFactory;
        let isPasswordComplexityGroup1EnabledUI = context.getUIFactory('IsPasswordComplexityGroup1Enabled') as ControlFactory;
        let passwordComplexityGroup2ErrorMessage = context.getUIFactory('PasswordComplexityGroup2ErrorMessage.Value') as ControlFactory;
        let isPasswordComplexityGroup2EnabledUI = context.getUIFactory('IsPasswordComplexityGroup2Enabled') as ControlFactory;
        let passwordComplexityGroup3ErrorMessage = context.getUIFactory('PasswordComplexityGroup3ErrorMessage.Value') as ControlFactory;
        let isPasswordComplexityGroup3EnabledUI = context.getUIFactory('IsPasswordComplexityGroup3Enabled') as ControlFactory;
        let passwordComplexityGroup4ErrorMessage = context.getUIFactory('PasswordComplexityGroup4ErrorMessage.Value') as ControlFactory;
        let isPasswordComplexityGroup4EnabledUI = context.getUIFactory('IsPasswordComplexityGroup4Enabled') as ControlFactory;

        let maximumDaysForPasswordUI = context.getUIFactory("MaximumDaysForPassword") as ControlFactory;
        let minimumPasswordLengthUI = context.getUIFactory("MinimalPasswordLength") as ControlFactory;
        let minimumPasswordLengthErrorMessageUI = context.getUIFactory("MinimalPasswordLengthErrorMessage.Value") as ControlFactory;

        let passwordEntropyEnabledUI = context.getUIFactory("IsPasswordEntropyEnabled") as ControlFactory;
        let passwordEntropyLengthUI = context.getUIFactory("PasswordEntropyLength") as ControlFactory;
        let passwordEntropyErrorMessageUI = context.getUIFactory("PasswordEntropyErrorMessage") as ControlFactory;

        let passwordMultiCharUsageEnabledUI = context.getUIFactory("IsPasswordMultiCharUsageEnabled") as ControlFactory;
        let passwordMultiCharUsageLengthUI = context.getUIFactory("PasswordMultiCharUsageLength") as ControlFactory;
        let passwordMultiCharUsageErrorMessageUI = context.getUIFactory("PasswordMultiCharUsageErrorMessage") as ControlFactory;

        if (isEnabled() === false) {
            passwordEntropyEnabledUI.isEnabled(false);
            passwordEntropyLengthUI.isEnabled(false);
            passwordEntropyErrorMessageUI.isEnabled(false);
            passwordMultiCharUsageEnabledUI.isEnabled(false);
            passwordMultiCharUsageLengthUI.isEnabled(false);
            passwordMultiCharUsageErrorMessageUI.isEnabled(false);

            isPasswordChronicEnabledUI.isEnabled(false);
            lastChronicProhibitedUI.isEnabled(false);
            lastChronicProhibitedUIErrorMessage.isEnabled(false);
            passwordComplexityGroup1.isEnabled(false);
            passwordComplexityGroup2.isEnabled(false);
            passwordComplexityGroup3.isEnabled(false);
            passwordComplexityGroup4.isEnabled(false);
            passwordComplexityGroup1ErrorMessage.isEnabled(false);
            passwordComplexityGroup2ErrorMessage.isEnabled(false);
            passwordComplexityGroup3ErrorMessage.isEnabled(false);
            passwordComplexityGroup4ErrorMessage.isEnabled(false);
            isPasswordComplexityGroup1EnabledUI.isEnabled(false);
            isPasswordComplexityGroup2EnabledUI.isEnabled(false);
            isPasswordComplexityGroup3EnabledUI.isEnabled(false);
            isPasswordComplexityGroup4EnabledUI.isEnabled(false);
            maximumDaysForPasswordUI.isEnabled(false);
            minimumPasswordLengthUI.isEnabled(false);
            minimumPasswordLengthErrorMessageUI.isEnabled(false);
        }
        else {
            isPasswordChronicEnabledUI.isEnabled(true);
            maximumDaysForPasswordUI.isEnabled(true);
            minimumPasswordLengthUI.isEnabled(true);
            minimumPasswordLengthErrorMessageUI.isEnabled(true);

            passwordEntropyEnabledUI.isEnabled(true);
            passwordMultiCharUsageEnabledUI.isEnabled(true);

            isPasswordComplexityGroup1EnabledUI.isEnabled(true);
            isPasswordComplexityGroup2EnabledUI.isEnabled(true);
            isPasswordComplexityGroup3EnabledUI.isEnabled(true);
            isPasswordComplexityGroup4EnabledUI.isEnabled(true);

            if (isPasswordEntropyEnabled() === true) {
                passwordEntropyLengthUI.isEnabled(true);
                passwordEntropyErrorMessageUI.isEnabled(true);
            } else {
                passwordEntropyLengthUI.isEnabled(false);
                passwordEntropyErrorMessageUI.isEnabled(false);
            }

            if (isPasswordMultiCharUsageEnabled() === true) {
                passwordMultiCharUsageLengthUI.isEnabled(true);
                passwordMultiCharUsageErrorMessageUI.isEnabled(true);
            } else {
                passwordMultiCharUsageLengthUI.isEnabled(false);
                passwordMultiCharUsageErrorMessageUI.isEnabled(false);
            }

            if (isPasswordChronicEnabled() === true) {
                lastChronicProhibitedUI.isEnabled(true);
                lastChronicProhibitedUIErrorMessage.isEnabled(true);
            } else {
                lastChronicProhibitedUI.isEnabled(false);
                lastChronicProhibitedUIErrorMessage.isEnabled(false);
            }

            if (isPasswordComplexityGroup1Enabled() === true) {
                passwordComplexityGroup1.isEnabled(true);
                passwordComplexityGroup1ErrorMessage.isEnabled(true);
            } else {
                passwordComplexityGroup1.isEnabled(false);
                passwordComplexityGroup1ErrorMessage.isEnabled(false);
            }
            if (isPasswordComplexityGroup2Enabled() === true) {
                passwordComplexityGroup2.isEnabled(true);
                passwordComplexityGroup2ErrorMessage.isEnabled(true);
            } else {
                passwordComplexityGroup2.isEnabled(false);
                passwordComplexityGroup2ErrorMessage.isEnabled(false);
            }
            if (isPasswordComplexityGroup3Enabled() === true) {
                passwordComplexityGroup3.isEnabled(true);
                passwordComplexityGroup3ErrorMessage.isEnabled(true);
            } else {
                passwordComplexityGroup3.isEnabled(false);
                passwordComplexityGroup3ErrorMessage.isEnabled(false);
            }
            if (isPasswordComplexityGroup4Enabled() === true) {
                passwordComplexityGroup4.isEnabled(true);
                passwordComplexityGroup4ErrorMessage.isEnabled(true);
            } else {
                passwordComplexityGroup4.isEnabled(false);
                passwordComplexityGroup4ErrorMessage.isEnabled(false);
            }
        }
    }
}

ComponentManager.setUIListener('PasswordPolicyUIListener', PasswordPolicyUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('ModulAViewExtension.UIListeners.TreeViewSelectorTest.PasswordPolicyUIListener', PasswordPolicyUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');